import { i18n } from '@fs/zion-locale'

export default {
  communtiyTitle: () => i18n.t('communtiyTitle', 'Community Help'),
  communityParagraph: () =>
    i18n.t(
      'joinACommunityParagraph',
      'Join a group in the <communityLink>FamilySearch online community</communityLink>.'
    ),
  communityLinkText: () => i18n.t('communityLinkText', 'FamilySearch online community'),

  noResultsHeading: () => i18n.t('SearchSuggestions.longWayHeading', "You've come a long way!"),

  searchLimitParagraph: () =>
    i18n.t(
      'SearchSuggestions.searchLimitParagraph',
      'The search tool loads a maximum of 2,000 results. If you see more than 2,000, consider narrowing your search so you see only the most relevant results.<br><br> Here are some strategies you can try:'
    ),

  placeHeading: () => i18n.t('SearchSuggestions.placeHeading', '1. Place'),

  placesWithinParagraph: () =>
    i18n.t(
      'SearchSuggestions.placesWithinParagraph',
      'Add a place to your search to narrow your result. <br><br> If you have a place already, choose one of the options under Places within to view search results connected to a smaller, more specific place—a city or county, for example, located within the county or state mentioned in the initial search.<br><br> You can also select the option to exclude Places within to only search for records at the place level you entered and not for more specific places within that level.'
    ),

  lifeEvent: () => i18n.t('SearchSuggestions.lifeEventHeading', '2. Life event and record types'),

  lifeEventParagraph: () =>
    i18n.t(
      'SearchSuggestions.lifeEventParagraph',
      'Add a life event—a birth, marriage, or death, for example.<br><br> A life event consists of several related record types. If you have selected a life event already, try de-selecting any record types below the Life Event dropdown that don’t match what you are looking for.'
    ),

  date: () => i18n.t('SearchSuggestions.dateHeading', '3. Date'),

  dateParagraph: () =>
    i18n.t(
      'dateParagraph',
      'Add a date or date range to your search.<br><br> If the current search includes a date range, try a smaller date range or even a specific year.'
    ),

  imageGroup: () => i18n.t('SearchSuggestions.imageGroupHeading', '4. Image group number'),

  imageGroupParagraph: () =>
    i18n.t(
      'SearchSuggestions.imageGroupParagraph',
      'If you know the image group number for the records that interest you, you can click the option for advanced search and enter it. Your search results will be tied to that specific image group.'
    ),

  keyword: () => i18n.t('SearchSuggestions.keywordHeading', '5. Keyword'),

  keywordParagraph: () =>
    i18n.t(
      'SearchSuggestions.keywordParagraph',
      'Enter a keyword that you think would appear in the Title, Volume, Archival Reference Number, or Creator field of the record or image group you want to find. If the new search results are too few or narrow, try a different keyword.'
    ),

  collectionsResultNarrowTip1: () =>
    i18n.t(
      'CollectionsSearchSuggestions.collectionsResultNarrowTipParagraph1',
      'This page loads a maximum of 2,000 collection results. If you see more than 2,000 results, consider applying some filters so you see only the most relevant collections.'
    ),
  collectionsResultNarrowTip2: () =>
    i18n.t(
      'CollectionsSearchSuggestions.collectionsResultNarrowTipParagraph2',
      'Using the options in the side panel, you can filter collection results by a keyword search, life events, a place, or date range.'
    ),
}
